let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("75QNi")).then(() => parcelRequire('amZ6g'));